import { memo, useCallback } from 'react'

import { TextField } from '@mui/material'
import { MediaChannelInsert } from '@nativewaves/nw-cloud-sdk/media'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useShallow } from 'zustand/react/shallow'

import {
  useSubmissionProgressStore,
  selectSubmissionProgressSetters,
  SubmissionProgress,
} from '@shared/components/SubmissionProgress'
import { DialogFormContent } from '@shared/layouts'
import { useMediaChannelCreateMutation } from 'hooks/mutations/publishing'

type FormStructure = MediaChannelInsert

const NewDialogRaw = () => {
  const { t } = useTranslation(['common', 'domain'])

  const { setCurrentStep } = useSubmissionProgressStore(useShallow(selectSubmissionProgressSetters))

  // const { environmentId } = mediaChannelsRoute.useParams()

  const { mutate: createMediaChannel, isSuccess, isError } = useMediaChannelCreateMutation()

  const { handleSubmit, control } = useForm<FormStructure>({
    defaultValues: {},
  })

  const handleFormSubmit = useCallback(
    (data: FormStructure) => {
      setCurrentStep({ value: 10, description: `${t('domain:MediaChannel.creating')} ${data.name}` })

      createMediaChannel(
        { mediaChannelInsert: data },
        {
          onSuccess: (data) => {
            setCurrentStep({ value: 100, description: `${data.name} ${t('domain:MediaChannel.created')}` })
          },
          onError: (_, variables) => {
            setCurrentStep({
              value: 100,
              description: `${variables.mediaChannelInsert.name} ${t('domain:MediaChannel.couldNotBeCreated')}`,
            })
          },
        },
      )
    },
    [t, createMediaChannel, setCurrentStep],
  )

  return (
    <DialogFormContent
      onSubmit={handleSubmit(handleFormSubmit)}
      title={t('domain:MediaChannel.AddMediaChannel')}
      description={t('domain:MediaChannel.entityCreateDescription')}
      SubmitProgressZone={<SubmissionProgress isSuccess={isSuccess} isError={isError} />}
    >
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            autoFocus
            margin="dense"
            label={t('name')}
            type="text"
            fullWidth
            variant="standard"
            required
            autoComplete="off"
          />
        )}
      />
    </DialogFormContent>
  )
}

export const NewDialog = memo(NewDialogRaw)
